// extracted by mini-css-extract-plugin
export default {"container":"QRCodeGenerator_container__+E3Vs","tooltip":"QRCodeGenerator_tooltip__4FeHc"};